export default __webpack_public_path__ + "static/media/May2016.8a43db6b.png";